import VaspDetails from './VaspDetails'

export default VaspDetails
